import styled from 'styled-components';
import PCTop from './PC/PCTop';
import MobileTop from './Mobile/MobileTop';
import PCSection1 from './PC/PCSection1';
import PCSection2 from './PC/PCSection2';
import PCSection3 from './PC/PCSection3';
import PCSection4 from './PC/PCSection4';
import PCSection5 from './PC/PCSection5';
import PCFooter from './PC/PCFooter';
import MobileSection1 from './Mobile/MobileSection1';
import MobileSection2 from './Mobile/MobileSection2';
import MobileSection3 from './Mobile/MobileSection3';
import MobileSection4 from './Mobile/MobileSection4';
import MobileSection5 from './Mobile/MobileSection5';
import MobileFooter from './Mobile/MobileFooter';

const Web = styled.div`
    width: 100vw;
    height: 100vh;

    @media (min-width: 0px) and (max-width: 679px) {
        display: none;
    }
`;

const Mobile = styled.div`
    width: 100vw;
    height: 100vh;

    @media (min-width: 680px) and (max-width: 20000px) {
        display: none;
    }
`;

function Main() {
    return (
        <>
            <Web>
                <PCTop />
                <PCSection1 />
                <PCSection2 />
                <PCSection3 />
                <PCSection4 />
                <PCSection5 />
                <PCFooter />
            </Web>
            <Mobile>
                <MobileTop />
                <MobileSection1 />
                <MobileSection2 />
                <MobileSection3 />
                <MobileSection4 />
                <MobileSection5 />
                <MobileFooter />
            </Mobile>
        </>
    );
}

export default Main;
